import { render, staticRenderFns } from "./StationResearchDetail.vue?vue&type=template&id=5dafba4e&scoped=true&"
import script from "./StationResearchDetail.vue?vue&type=script&lang=js&"
export * from "./StationResearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./StationResearchDetail.vue?vue&type=style&index=0&id=5dafba4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dafba4e",
  null
  
)

export default component.exports